export type LabelKey =
	| 'Area'
	| 'All'
	| 'Before'
	| 'BreadcrumbNavigation'
	| 'Category'
	| 'City'
	| 'CurrentPage'
	| 'DateRangePlaceholder'
	| 'Deadline'
	| 'Email'
	| 'Friday'
	| 'HistoricalArchive'
	| 'JobCategory'
	| 'Menu'
	| 'Minutes'
	| 'Monday'
	| 'Name'
	| 'NextMonth'
	| 'NextPage'
	| 'Notice'
	| 'NumberOfResultsPerPage'
	| 'OutOf'
	| 'Page'
	| 'Pages'
	| 'PreviousMonth'
	| 'PreviousPage'
	| 'Publication'
	| 'RelatedNews'
	| 'RelatedPages'
	| 'RelatedPublications'
	| 'ResultsPerPage'
	| 'Saturday'
	| 'Sunday'
	| 'ThePageDoesNotExistSearchHeading'
	| 'Tuesday'
	| 'Title'
	| 'Thursday'
	| 'Tomorrow'
	| 'TotalResults'
	| 'Type'
	| 'ValidFrom'
	| 'ValidTo'
	| 'Wednesday'
	| 'Question'
	| 'ZipCode';

interface DictionaryFunctions {
	get(key: LabelKey): string;
}

export const LabelItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: LabelKey): string => {
			switch (key) {
				case 'Area':
					return getValue('Labels.Area', 'Område');
				case 'All':
					return getValue('Labels.All', 'Alle');
				case 'Before':
					return getValue('Labels.Before', 'Inden');
				case 'BreadcrumbNavigation':
					return getValue('Labels.BreadcrumbNavigation', 'Brødkrumme navigation');
				case 'Category':
					return getValue('Labels.Category', 'Kategori');
				case 'City':
					return getValue('Labels.City', 'By');
				case 'CurrentPage':
					return getValue('Labels.CurrentPage', 'Nuværende side');
				case 'DateRangePlaceholder':
					return getValue('Labels.DateRangePlaceholder', 'Indtast dato interval');
				case 'Deadline':
					return getValue('Labels.Deadline', 'Ansøgningsfrist');
				case 'Email':
					return getValue('Labels.Email', 'E-mail');
				case 'Friday':
					return getValue('Labels.Friday', 'Fredag');
				case 'HistoricalArchive':
					return getValue('Labels.HistoricalArchive', 'Historisk arkiv');
				case 'JobCategory':
					return getValue('Labels.JobCategory', 'Jobkategori');
				case 'Menu':
					return getValue('Labels.Menu', 'Menu');
				case 'Minutes':
					return getValue('Labels.Minutes', 'Minutter');
				case 'Monday':
					return getValue('Labels.Monday', 'Mandag');
				case 'Name':
					return getValue('Labels.Name', 'Navn');
				case 'NextMonth':
					return getValue('Labels.NextMonth', 'Næste måned');
				case 'NextPage':
					return getValue('Labels.NextPage', 'Næste side');
				case 'Notice':
					return getValue('Labels.Notice', 'Bemærk');
				case 'NumberOfResultsPerPage':
					return getValue('Labels.NumberOfResultsPerPage', 'Antal resultater pr. side');
				case 'OutOf':
					return getValue('Labels.OutOf', 'Ud af');
				case 'Page':
					return getValue('Labels.Page', 'Side');
				case 'Pages':
					return getValue('Labels.Pages', 'Sider');
				case 'PreviousMonth':
					return getValue('Labels.PreviousMonth', 'Forrige måned');
				case 'PreviousPage':
					return getValue('Labels.PreviousPage', 'Forrige side');
				case 'Publication':
					return getValue('Labels.Publication', 'Publikation');
				case 'RelatedNews':
					return getValue('Labels.RelatedNews', 'Relaterede nyheder');
				case 'RelatedPages':
					return getValue('Labels.RelatedPages', 'Relaterede sider');
				case 'RelatedPublications':
					return getValue('Labels.RelatedPublications', 'Relaterede publikationer');
				case 'ResultsPerPage':
					return getValue('Labels.ResultsPerPage', 'Resultater pr. side');
				case 'Saturday':
					return getValue('Labels.Saturday', 'Lørdag');
				case 'Sunday':
					return getValue('Labels.Sunday', 'Søndag');
				case 'ThePageDoesNotExistSearchHeading':
					return getValue('Labels.ThePageDoesNotExistSearchHeading', 'Siden findes ikke');
				case 'Title':
					return getValue('Labels.Title', 'Titel');
				case 'TotalResults':
					return getValue('Labels.TotalResults', 'Resultater i alt');
				case 'Tuesday':
					return getValue('Labels.Tuesday', 'Tirsdag');
				case 'Thursday':
					return getValue('Labels.Thursday', 'Torsdag');
				case 'Tomorrow':
					return getValue('Labels.Tomorrow', 'I morgen');
				case 'Type':
					return getValue('Labels.Type', 'Type');
				case 'ValidFrom':
					return getValue('Labels.ValidFrom', 'Gyldig fra');
				case 'ValidTo':
					return getValue('Labels.ValidTo', 'Gyldig til');
				case 'Wednesday':
					return getValue('Labels.Wednesday', 'Onsdag');
				case 'Question':
					return getValue('Labels.Question', 'Spørgsmål');
				case 'ZipCode':
					return getValue('Labels.ZipCode', 'Postnr.');
			}
		},
	};
};
